export default "__VITE_ASSET__hYVpPSQk__"